import { selectModule, selectModuleState, selectStyle } from "Redux/appSlice";
import { useAppSelector } from "Redux/hooks";

/*
  @function ModuleShower
  rendere module name and chapter name
  @returns {React.Node}
*/
export default function ModuleShower() {
  const { color2 } = useAppSelector(selectStyle);
  const module = useAppSelector(selectModule);
  const moduleState = useAppSelector(selectModuleState);
  const FINAL_REPORT = "FINAL REPORT";
  return (
    <div  className="flex flex-col items-center ">
      <h2 style={{ color: color2 }} className="uppercase">
        {module ? module?.module_name : ""}
      </h2>
      <h3 style={{ color: color2 }}>
        {moduleState && module
          ? moduleState.initialization.currentChapter === -1
            ? FINAL_REPORT
            : module.chapters[moduleState.initialization.currentChapter]?.name
          : ""}
      </h3>
    </div>
  );
}
